import React from "react";
import jotaImg from "assets/img/jota.png";

const JotaAvatar = ({ size = 120 }) => {
	return (
		<img
			src={jotaImg}
			alt="JOTA"
			width={size}
			height={size}
			style={{ width: size, height: size, objectFit: "cover" }}
		/>
	);
};

export default JotaAvatar;
